import React from 'react';
import { BankPromotionsTracker } from './components/BankPromotionsTracker';
export function App() {
  return <BankPromotionsTracker data-id="element-0" />;
}